import { DollarCircleFilled, MediumCircleFilled, PercentageOutlined, PlusCircleFilled } from '@ant-design/icons'

export const colorTypeMatch = {
  FREIGHT: { bg: '#e8e2ff', color: '#725AC1', icon: <DollarCircleFilled className='mr-2' /> },
  FEE: {
    bg: 'var(--theme-color-1-dim)',
    color: 'var(--theme-color-1)',
    icon: <DollarCircleFilled className='mr-2' />,
  },
  ADJUSTMENT: {
    bg: 'var(--theme-warning-dim)',
    color: 'var(--theme-warning)',
    icon: <MediumCircleFilled className='mr-2' />,
  },
  ADDITIVE: { bg: 'var(--theme-option)', color: 'var(--gray-100)', icon: <DollarCircleFilled className='mr-2' /> },
  ADDITIVE_ADJUSTMENT: { bg: '#fef1ea', color: '#ce5e23', icon: <PlusCircleFilled className='mr-2' /> },
  TAX: {
    bg: 'var(--theme-success-dim)',
    color: 'var(--theme-success)',
    icon: <PercentageOutlined className='mr-2' />,
  },
}

export const removeUnderscore = (str: string) => {
  return str.replace(/_/g, ' ')
}
